import {AfterViewChecked, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { Location } from '@angular/common';
import {Router} from '@angular/router';
import {MenuItem} from 'primeng/api';

@Component({
   selector: 'app-menu-lateral',
   templateUrl: './menu-lateral.component.html',
   styleUrls: ['./menu-lateral.component.scss'],
   styles: [
      `
      [nz-menu] {
        width: 240px;
      }
    `
   ]
})
export class MenuLateralComponent implements OnChanges {
   @Input()
   list: MenuItem[] = [];
   @Input()
   responsive = false;
   @Input()
   windowWidth: number = 0;
   
   showMobileMenu = false
   
   constructor(
     private readonly _router: Router,
     private readonly _location: Location
   ) {}
   
   realizarAccion(opcionHija: MenuItem) {
      if(opcionHija?.badge && opcionHija?.badge === 'external'){
         const url = this._location.prepareExternalUrl(this._router.serializeUrl(
           this._router.createUrlTree([opcionHija.routerLink])
         ));
         window.open(url, '_blank');
         return
      }
      void this._router.navigate([opcionHija.routerLink]);
   }
   
   ngOnChanges(changes: SimpleChanges): void {
      this.showMobileMenu = changes?.windowWidth?.currentValue <= 992
   }
   
   eventChange(evento: any) {
      console.log(evento);
   }
}
